import React from 'react';
import { Flags } from '../../../components';
import messages from '../messages';
export const markets = (t, b2cUnifiedDomainLocalesList) => {
    const marketsObj = {
        'de-AT': {
            flag: React.createElement(Flags.AtFlag, null),
            country: t(messages.Austria),
            link: 'https://www.weltsparen.at/',
            locale: 'de-AT',
            preferredLocale: 'de-at',
            redirectTarget: ['at', 'aut'],
        },
        'fr-FR': {
            flag: React.createElement(Flags.FrFlag, null),
            country: t(messages.France),
            link: 'https://www.raisin.com/fr-fr/',
            locale: 'fr-FR',
            preferredLocale: 'fr-fr',
            redirectTarget: ['fr', 'fra'],
        },
        'de-DE': {
            flag: React.createElement(Flags.DeFlag, null),
            country: t(messages.Germany),
            link: 'https://www.weltsparen.de/',
            locale: 'de-DE',
            preferredLocale: 'de-de',
            redirectTarget: ['de', 'deu'],
        },
        'en-IE': {
            flag: React.createElement(Flags.IeFlag, null),
            country: t(messages.Ireland),
            link: 'https://www.raisin.ie/',
            locale: 'en-IE',
            preferredLocale: 'en-ie',
            redirectTarget: ['ie', 'irl'],
        },
        'nl-NL': {
            flag: React.createElement(Flags.NlFlag, null),
            country: t(messages.Netherlands),
            link: 'https://www.raisin.nl/',
            locale: 'nl-NL',
            preferredLocale: 'nl-nl',
            redirectTarget: ['nl', 'nld'],
        },
        'es-ES': {
            flag: React.createElement(Flags.EsFlag, null),
            country: t(messages.Spain),
            link: 'https://www.raisin.es/',
            locale: 'es-ES',
            preferredLocale: 'es-es',
            redirectTarget: ['es', 'esp'],
        },
        'en-GB': {
            flag: React.createElement(Flags.GbFlag, null),
            country: t(messages.UnitedKingdom),
            link: 'https://www.raisin.co.uk/',
            locale: 'en-GB',
            preferredLocale: 'en-gb',
            redirectTarget: ['gb', 'gbr'],
        },
        us: {
            flag: React.createElement(Flags.UsFlag, null),
            country: t(messages.UnitedStates),
            link: 'https://www.raisin.com/en-us/',
            locale: 'en-US',
            preferredLocale: 'en-us',
            redirectTarget: ['us', 'usa'],
        },
        'pl-PL': {
            flag: React.createElement(Flags.PlFlag, null),
            country: t(messages.Poland),
            link: 'https://www.raisin.com/pl-pl/',
            locale: 'pl-PL',
            preferredLocale: 'pl-pl',
            redirectTarget: ['pl', 'pol'],
        },
        'fi-FI': {
            flag: React.createElement(Flags.FiFlag, null),
            country: t(messages.Finland),
            link: 'https://www.raisin.com/fi-fi/',
            locale: 'fi-FI',
            preferredLocale: 'fi-fi',
            redirectTarget: ['fi', 'fin'],
        },
    };
    const sortedMarkets = Object.fromEntries(Object.entries(marketsObj).sort(([, a], [, b]) => a.country.localeCompare(b.country, 'en', { ignorePunctuation: true })));
    sortedMarkets.en = {
        flag: React.createElement(Flags.EuFlag, null),
        country: t(messages.EU),
        link: 'https://www.raisin.com/en/',
        locale: 'other',
        preferredLocale: 'en',
        redirectTarget: ['eu', 'eur'],
    };
    if (!b2cUnifiedDomainLocalesList || !b2cUnifiedDomainLocalesList.length) {
        return sortedMarkets;
    }
    return Object.fromEntries(Object.entries(sortedMarkets).map(([locale, market]) => {
        const loweredLocale = locale.toLowerCase();
        if (b2cUnifiedDomainLocalesList === null || b2cUnifiedDomainLocalesList === void 0 ? void 0 : b2cUnifiedDomainLocalesList.includes(loweredLocale)) {
            market.link = `https://www.raisin.com/${loweredLocale}/`;
        }
        return [locale, market];
    }));
};
//# sourceMappingURL=CountryPickerConfig.js.map